import { Controller } from '@hotwired/stimulus'
import toastr from 'toastr'

export default class extends Controller {
  static values = {
    modalSelector: { type: String, default: '#lemonway-widget-modal' },
    errorMessage: String
  }

  async submit(event) {
    event.preventDefault()
    if (this.loading) return

    this.loading = true
    this.submitButtons.forEach((button) => { button.disabled = true })
    this.modal.open()

    try {
      const response = await fetch(this.element.action, {
        method: 'POST',
        body: new FormData(this.element),
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': this.csrfToken
        }
      })

      this.handle(await response.json())
    } catch (error) {
      this.fail(this.errorMessageValue)
    } finally {
      this.loading = false
      this.submitButtons.forEach((button) => { button.disabled = false })
    }
  }

  handle({ url, redirect_url: redirectUrl, error }) {
    if (error) return this.fail(error)
    if (redirectUrl) return window.location.assign(redirectUrl)
    if (!url) return this.fail(this.errorMessageValue)
    if (this.modal.isOpen) this.modal.start(url)
  }

  fail(message) {
    if (this.modal.isOpen) this.modal.close()
    toastr.error(message)
  }

  get modal() {
    const element = document.querySelector(this.modalSelectorValue)

    return this.application.getControllerForElementAndIdentifier(element, 'lemonway-modal')
  }

  get submitButtons() {
    return this.element.querySelectorAll('[type="submit"]')
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
